"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckRealNameRequest = void 0;
var CheckRealNameRequest = /** @class */ (function () {
    function CheckRealNameRequest() {
    }
    return CheckRealNameRequest;
}());
exports.CheckRealNameRequest = CheckRealNameRequest;
;
//# sourceMappingURL=checkRealName.request.js.map